import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

/* eslint-disable no-underscore-dangle */
export default class Header {
  constructor({ header, htmlBody }) {
    this.header = header;
    this.htmlBody = htmlBody;
    this.mobileMenu = this.header.find('.mobile-menu');
    this.mobileNav = this.htmlBody.find('#mobileMenuContainer');
    this.mobileNavOverlay = this.htmlBody.find('#mobileMenuContainer .header__site-nav__dropdown__overlay');
    this.mobileMenuMask = this.htmlBody.find('.mobile-menu-mask');
    // dev //dd=dropdown
    this.ddProjectsLink = this.header.find('.header__site-nav .has-dropdown--projects');
    this.ddProjectsContainer = this.header.find('#projectsDropdown');
    this.ddProjectsBG = this.header.find('.header__site-nav__dropdown__bg');

    this.init();
  }

  init = () => {
    this.htmlBody.on('click', '.mobile-menu', this.handleMobileMenu);
    this.dorpdownMenu();
    // Contact/Alliances page
    $('#mobileMenuContactPageEnquirey').on('click', () => {
      $('.mobile-menu').click();
    });
  };

  handleMobileMenu = () => {
    if (this.mobileMenu.hasClass('cross')) {
      this.mobileMenu.removeClass('cross');
      this.htmlBody.removeClass('no-scroll');
      this.mobileNav.removeClass('inn');
      this.mobileNavOverlay.fadeOut('fast');
      this.header.css('overflow-x', 'hidden');
      enableBodyScroll(document.querySelector('.header__site-nav--mobile'));
    } else {
      this.mobileMenu.addClass('cross');
      this.htmlBody.addClass('no-scroll');
      this.mobileNav.addClass('inn');
      this.mobileNavOverlay.fadeIn('fast');
      this.header.css('overflow-x', 'unset');
      disableBodyScroll(document.querySelector('.header__site-nav--mobile'));
    }
  };

  dorpdownMenu = () => {
    this.ddProjectsLink.on('mouseenter', (e) => {
      $(e.currentTarget).addClass('active');
      this.htmlBody.addClass('no-scroll');
      this.ddProjectsContainer.fadeIn('fast');
      e.stopPropagation();
    });

    // hide nav
    if (window.innerWidth >= 1024) {
      $('.header, .header__site-nav__dropdown__overlay, .header__site-nav--list-item:not(.has-dropdown--projects),.header__logo,.header__top,.header__utility-nav,.header__site-nav--list').on('mouseenter', () => {
        this.ddProjectsLink.removeClass('active');
        this.htmlBody.removeClass('no-scroll');
        this.ddProjectsContainer.fadeOut('fast');
      });
    }
  }
}
